import axios from "axios";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExclusiveListDetail, ExclusiveListSummary } from "../models";

const API_PATH = "exclusivelists/";

export const fetchExclusiveLists = createAsyncThunk(
  "exclusiveLists/fetchList",
  async (data: { keyword: string; pageNumber: number }) => {
    const res = await axios.get(`${API_PATH}list`, {
      params: {
        keyword: data.keyword,
        pageNumber: data.pageNumber,
      },
    });
    return res.data.data;
  }
);

export const fetchExclusiveListDetail = createAsyncThunk(
  "exclusiveLists/fetchDetail",
  async (id: string) => {
    const res = await axios.get(`${API_PATH}detail`, {
      params: { id },
    });
    return res.data.data as ExclusiveListDetail;
  }
);

export interface Pagination {
  pageNumber: number;
  pageSize: number;
  total: number;
}

export interface ExclusiveListsState {
  lists: ExclusiveListSummary[];
  currentDetail: ExclusiveListDetail | null;
  loading: boolean;
  keyword: string;
  pagination: Pagination;
}

const initialState: ExclusiveListsState = {
  lists: [],
  currentDetail: null,
  loading: false,
  keyword: "",
  pagination: {
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  },
};

const exclusiveListsSlice = createSlice({
  name: "exclusiveLists",
  initialState,
  reducers: {
    setKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload;
      state.pagination.pageNumber = 1;
    },
    setPagination: (state, action: PayloadAction<Partial<Pagination>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExclusiveLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExclusiveLists.fulfilled, (state, action) => {
        state.loading = false;
        state.lists = action.payload.items || [];
        state.pagination.total = action.payload.total || 0;
        state.pagination.pageNumber = action.payload.pageNumber || 1;
        state.pagination.pageSize = action.payload.pageSize || 20;
      })
      .addCase(fetchExclusiveListDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExclusiveListDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.currentDetail = action.payload;
      });
  },
});

export const { setKeyword, setPagination } = exclusiveListsSlice.actions;
export default exclusiveListsSlice;
